module.exports = __webpack_public_path__ + "static/media/vanilla-profile.d4b45420.jpg";